import http from "@/common/http.service";
const ROOT_URL = "automation/search";
const DELETE_URL = "automation/";
const DELETE_CAMP_URL = "automation/campaign/";
const SAVE_DATA = "automation";
const GET_AUOTOMATION = "automation/";

const RECIPIENT_LIST = "list/lookup";
const SEGMENT_LIST = "list/segment";
const FORM_LIST = "form-dropdown";

const CAMP_LIST = "automation/campaign/list";

const COMMON_VALIDATE = "automation/commonvalidation/";

const RULE_UPDATE = "automation/rule-update/";
const PUBLISH = "automation/publish/";

const DUPLICATE_CAMP = "campaign/clone/";
const DUPLICATE_AUTO = "automation/clone/";

const DEACTIVATE = "automation/actions/inactivate/";
const ACTIVATE = "automation/actions/activate/";

// report apis
const AUTO_REPORT = "automation/delivery-report/";
const AUTO_CAMP_REPORT = "automation/campaignwise-report/";

export default {
  fetchItems(params, cb) {
    http.post(ROOT_URL, params).then((response) => {
      var data = { items: response.data.data, total: response.data.count };
      cb(data);
    });
  },

  delete(id) {
    return http.deleteRecord(DELETE_URL + id);
  },

  deleteCamp(id, autoId) {
    return http.deleteRecord(DELETE_CAMP_URL + autoId + "/" + id);
  },

  getRecipients(params, cb) {
    return http.post(RECIPIENT_LIST, params).then(function (response) {
      var data = { list: response.data.data, count: response.data.count };
      cb(data);
    });
  },

  getSegments(params, cb) {
    return http.post(SEGMENT_LIST, params).then(function (response) {
      var data = { list: response.data.data, count: response.data.count };
      cb(data);
    });
  },

  getForms(params, cb) {
    return http.post(FORM_LIST, params).then(function (response) {
      var data = { list: response.data.data, count: response.data.count };
      cb(data);
    });
  },

  getSingleItem(id, isPreview) {
    return http.get(GET_AUOTOMATION + (isPreview ? "preview/" : "") + id);
  },

  saveData(params) {
    if (params.id) {
      const url = SAVE_DATA + "/" + params.id;
      delete params.id;
      return http.put(url, params);
    } else {
      return http.post(SAVE_DATA, params);
    }
  },

  duplicateAuto(params) {
    const url = DUPLICATE_AUTO + params.id;
    delete params.id;
    return http.post(url, params);
  },

  saveName(params) {
    const url = SAVE_DATA + "/" + params.id;
    delete params.id;
    return http.patch(url, params);
  },

  getCamps(params) {
    return http.post(CAMP_LIST, params);
  },

  updateRulesAndCamps(params) {
    const url = RULE_UPDATE + params.id;
    delete params.id;
    return http.patch(url, params);
  },

  publishAuto(params) {
    const url = PUBLISH + params.id;
    return http.patch(url, { skipQuota: params.skipQuota });
  },

  commonValidate(id) {
    const url = COMMON_VALIDATE + id;
    return http.post(url, {});
  },

  activateAuto(params) {
    const url = ACTIVATE + params.id;
    return http.patch(url, { skipQuota: params.skipQuota });
  },

  deactivateAuto(params) {
    const url = DEACTIVATE + params.id;
    return http.patch(url, {});
  },

  duplicateCamp(params) {
    const url = DUPLICATE_CAMP + params.id;
    return http.post(url, {});
  },

  // report section

  automationReport(id) {
    return http.get(AUTO_REPORT + id);
  },

  automationCampaignReport(id) {
    return http.get(AUTO_CAMP_REPORT + id);
  },

  exportItems(params, { name }, cb) {
    return http.post(ROOT_URL, params, name);
  },
};
